import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs';

// Temporary interceptor to surface API migration errors in the console.
// Remove before merging to main.
export const apiMigrationDebugInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(
    tap({
      error: (err) => {
        console.error(`[API-MIGRATION] ${err.status} ${req.method} ${req.url}`)
      }
    })
  )
}
